.disclosure {
  border: 1px solid var(--line-subtle);
  border-radius: var(--radius-md);
  background: var(--surface-inset);
}

.summary {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-4);
  padding: var(--space-4);
  color: var(--ink-primary);
  font-family: var(--font-display);
  font-size: var(--text-sm);
  letter-spacing: var(--tracking-wide);
  list-style: none;
  cursor: pointer;
}

.summary::-webkit-details-marker {
  display: none;
}

.summary:hover {
  background: var(--surface-hover);
}

.summary:focus-visible {
  outline: var(--focus-ring);
  outline-offset: var(--focus-offset);
}

.indicator::before {
  content: '+';
  color: var(--accent);
  font-family: var(--font-mono);
}

.disclosure[open] .indicator::before {
  content: '−';
}

.content {
  padding: 0 var(--space-4) var(--space-4);
  color: var(--ink-secondary);
  font-size: var(--text-sm);
  line-height: var(--leading-relaxed);
}
